// @ts-nocheck
/**
 * Pools — its own page, and only pools.
 *
 * The old /scheduling/overview screen carried pools, brackets, history and
 * three summary panels on one 7,500px page. This route shows the division
 * chips and the pools in the chosen division, and nothing else.
 */
import * as React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import PoolsPanel from '@/components/admin/schedule/PoolsPanel';
import { SchedulingPageShell } from '@/components/admin/schedule/SchedulingPageShell';
import { useDivisionNav } from '@/hooks/useDivisionNav';

export default function OperatorEventPoolsPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const { event } = useDivisionNav(eventId);
  const [token, setToken] = React.useState(0);

  return (
    <SchedulingPageShell
      title="Pools"
      subtitle={event?.name}
      actions={
        <Button size="sm" variant="outline" asChild>
          <Link to={`/admin-dashboard/events/${eventId}/scheduling/grid`}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Grid
          </Link>
        </Button>
      }
    >
      <div className="w-full space-y-4">
        <p className="text-sm text-muted-foreground">
          Add or remove pools, move teams between them and set the order teams finish in.
        </p>
        <PoolsPanel
          key={token}
          eventId={eventId!}
          hideHeading
          onChanged={() => setToken((t) => t + 1)}
        />
      </div>
    </SchedulingPageShell>
  );
}
